import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShieldCheck } from "lucide-react";

function formatAuditDetails(log) {
  if (log.after) return JSON.stringify(log.after);
  if (log.before) return JSON.stringify(log.before);
  return "";
}

export default function AuditPage() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs", { params: { limit: 500 } }).then((r) => setLogs(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <h1 className="font-display font-bold text-3xl flex items-center gap-3">
          <ShieldCheck className="w-7 h-7 text-[#16A34A]" /> Journal d'audit
        </h1>
        <p className="text-slate-500 text-sm mt-1">Toutes les actions sensibles tracées de manière chronologique.</p>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
            <tr><th className="text-left p-3">Date</th><th className="text-left">Utilisateur</th><th className="text-left">Rôle</th><th className="text-left">Action</th><th className="text-left">Cible</th><th className="text-left">Détails</th></tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-t border-slate-200">
                <td className="p-3 text-xs font-mono text-slate-500 whitespace-nowrap">{new Date(l.created_at).toLocaleString("fr-FR")}</td>
                <td className="text-slate-700 text-xs">{l.user_email || "—"}</td>
                <td><span className="text-xs px-2 py-0.5 bg-slate-100 rounded font-mono">{l.user_role || "—"}</span></td>
                <td className="font-mono text-xs text-[#DC2626] font-semibold">{l.action}</td>
                <td className="text-slate-500 text-xs">{l.entity_type ? `${l.entity_type}/${l.entity_id || "—"}` : "—"}</td>
                <td className="text-slate-500 text-xs font-mono max-w-xs truncate">{formatAuditDetails(l)}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={6} className="text-center text-slate-400 py-12">Aucun événement</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
